import axios from 'axios';
import {
  IAccountCollection,
  IAccountListParams,
  IAccount,
  IBlockAccountPayload,
  ICreateAccountPayload,
  IDeleteAccountPayload,
  IUnblockAccountPayload,
  IUpdateAccountPayload,
  IUpdateSellerAccountPayload,
  IAccountBrandCollection,
  IAccountBrandsParams,
  IUpdateAccountBrandsPayload,
} from 'entities/Account/Account.models';

const basePath = 'account';

export const accountTransport = {
  get: (filters: IAccountListParams): Promise<IAccountCollection> => axios.get(`${basePath}`, { params: filters }),
  getById: (id: number): Promise<IAccount> => axios.get(`${basePath}/${id}`),
  create: (params: ICreateAccountPayload): Promise<IAccount> => axios.post(`${basePath}`, params),
  update: (params: IUpdateAccountPayload): Promise<IAccount> => axios.patch(`${basePath}`, params),
  delete: (params: IDeleteAccountPayload): Promise<IAccount> => axios.delete(`${basePath}`, { data: params }),
  block: (params: IBlockAccountPayload): Promise<IAccount> => axios.patch(`${basePath}/block`, params),
  unblock: (params: IUnblockAccountPayload): Promise<IAccount> => axios.patch(`${basePath}/unblock`, params),
  updateSellerAccount: (params: IUpdateSellerAccountPayload): Promise<IAccount> => axios.patch(`${basePath}/seller`, params),
  generateWebhookSign: (): Promise<IAccount> => axios.patch(`${basePath}/generate-webhook-sign`),
  getBrands: (filters: IAccountBrandsParams): Promise<IAccountBrandCollection> =>
    axios.get(`${basePath}/brands`, { params: filters }),
  updateBrands: (params: IUpdateAccountBrandsPayload): Promise<IAccountBrandCollection> =>
    axios.patch(`${basePath}/brands`, params),
};
